import { Component, OnInit, ViewChild, AfterViewInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterService } from '../../services/filter.service';
import { Observable } from 'rxjs';
import { JobService } from '../../services/jobs/job.service';
import { AllocateLearnerModalComponent } from './allocate-learner-modal/allocate-learner-modal.component';
import { MaterialsComponent } from '../../courses/materials/materials.component';
// import { AssignmentStatusComponent } from '../../../clients/assignment-status/assignment-status.component'
import { LearnersComponent } from '../../learners/learners.component'
import { MaterialService } from 'src/app/services/material.service';
import { Location, LocationStrategy } from '@angular/common';
import { TimeSheetService } from '../../services/time-sheet.service';
import { UserRoleService } from '../../services/user-role.service';
import { AssignmentStatusComponent } from '../../courses/assignment-status/assignment-status.component';


@Component({
  selector: 'app-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss']
})
export class JobComponent implements OnInit, AfterViewInit {
  job;
  closeBtnNeeded = true;
  learners: any = [];
  newMaterial: any = [];
  materials = [];
  length;
  pageSizeOptions: number[] = [25, 50, 100];
  jobId;
  displayedColumns: string[] = ['name', 'email', 'actions'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  displayAllocate: Boolean = true;
  currentUser;
  startDate;
  endDate;
  loading: boolean = false;
  jobForScheduler;
  completionPercent;
  clientDashboard;
  displayDetails = false
  sendDataToAllocateModal: { learners: any; materials: number; };
  learnersAlloted = false;
  user;
  @Input('jobIdFromClient') jobIdFromClient;
  @Input('jobFromClient') jobFromClient;


  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() jobTabIndex: EventEmitter<any> = new EventEmitter<any>();
  @Output() completionPercentForClient: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(MaterialsComponent, { static: false }) materialsComp: MaterialsComponent;
  @ViewChild(AssignmentStatusComponent, { static: false }) assignmentStatusComp: AssignmentStatusComponent;
  @ViewChild(LearnersComponent, { static: false }) learnersComp: LearnersComponent;
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  allLearners: any;
  learnerAssignmentStatus: any;
  displayLearnersTab = false;
  selectedTab = 0
  hideTitle = false;
  gettingLearners: boolean = false;
  gettingStatWithLearn: boolean = false;
  changeTab: boolean = true;
  isExamTab: boolean
  instForClient: any;
  allocated: boolean = false;
  materialsWithLearners: any;
  callGetMarks = false;
  unitNo: any;
  allUnitsList = []
  allAssignmentList = []
  hasPolicy;
  isEditJob
  quizStatusLearner
  userRole: string;

  constructor(public _timeSheetService: TimeSheetService, private router: Router, private location: Location, private locationStrategy: LocationStrategy,
    public _learnerService: LearnerService, public dialog: MatDialog, public _filter: FilterService,
    public _snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, private _jobService: JobService, public _userRoleService: UserRoleService,
    private _materialService: MaterialService,) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      // onSameUrlNavigation: 'ignore',
      return false;
    };

    this.learners = [];
    this.dataSource = new MatTableDataSource(this.learners);
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.router.url.includes('/client')) {
      this.hideTitle = true;
      this.changeTab = false;
    }
    console.log("what is the user role", this.user);

    console.log("previousRoute", this.activatedRoute)
    console.log("location", this.location)
    this.activatedRoute.queryParams.subscribe(qparams => {
      if (!qparams['currentTab']) {
        // this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { currentTab: 0 } });
      }
      else this.selectedTab = qparams['currentTab']
      console.log("in IF qparams['currentTab']", typeof qparams['currentTab'])
    })


    this.currentUser = JSON.parse(localStorage.currentUser);

    console.log("this.jobIdFromClient", this.jobIdFromClient);

    if (this.user.isClient) {
      this.clientDashboard = true;
      console.log("VIEW VALUE IS", this.clientDashboard)
    }
    if (this.jobFromClient) {
      console.log("##########this.jobFromClient onInit", this.jobFromClient);
      this.jobId = this.jobFromClient._id
      this.instForClient = this.job.instructors
      console.log("this.instForClient", this.instForClient)
      this.getJob()
      this.getLearners(this.jobId)
      // this.assignmentStatusWithLearner()
      if (this.learnersComp) {
        this.learnersComp.jobIdFromClient = this.jobId
      }

    }
    if (this.jobIdFromClient != undefined) {
      console.log("##########this.jobIdFromClient onInit", this.jobIdFromClient);
      this.jobId = this.jobIdFromClient._id
      this.getJob()
      this.getLearners(this.jobId)
      // this.assignmentStatusWithLearner()
      this.learnersComp.jobIdFromClient = this.jobId
    }
    else {
      this.activatedRoute.params.subscribe(params => {
        this.jobId = params['jobid'];
        console.log("Calling getLearners with jobid = ", this.jobId);
        if (this.jobId != undefined) {
          this.displayLearnersTab = true
          this.getJob();
          // this.assignmentStatusWithLearner()
          this.getLearners(this.jobId)
          // this.getMaterials()
        }
      });

    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    console.log("Changes in job", changes);
    if (changes.jobFromClient != undefined) {
      if (changes.jobFromClient.currentValue != undefined) {
        this.job = changes.jobFromClient.currentValue
        console.log("here is client course DATa::", this.job.course)
        if (this.job.course) {
          this.isExamTab = this.job.course.hasExam
        }

        this.jobId = changes.jobFromClient.currentValue._id
        console.log("&&&&&&&&&&this.jobId", this.jobId);
        this.instForClient = this.job.instructors
        console.log("this.instForClient", this.instForClient)
        this.getLearners(this.jobId)
        this.assignmentStatusWithLearner()
      }
    }
    // if (changes.jobFromClient && changes.jobFromClient.currentValue){
    //   console.log("##########this.jobFromClient On Changes", this.jobFromClient);
    // }
    else {
      console.log("@@@@@@@@@@NI JOBS FOUND@@@@@@@@@@@");
    }
  }

  jobChangedByClient(job) {
    console.log("in jobChangedByClient", job);
    this.job = job;
    this.jobId = job._id
    this.instForClient = this.job.instructors
    console.log("this.instForClient", this.instForClient)
    if (this.learnersComp) {
      this.learnersComp.jobIdFromClient = job._id;
    }
    this.getLearners(job._id)
    // this.learnersComp.getLearners(job._id);
    if (this.assignmentStatusComp) {
      this.assignmentStatusComp.assignmentStatusWithLearner()
    }

  }
  ngAfterViewInit(): void {

    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '600px', height: '600px' });
    return dialogRef.afterClosed();
  }

  loadLearners(object) {
    console.log("OBJECT", object);
    this.learners = object.learners;
    console.log("Learners loaded by event = ", object.learners);
  }
  addedLearner(object) {
    console.log("Object in addedLearner", object);
    this.assignmentStatusComp.ngOnInit();
  }
  loadMaterials(object) {
    console.log("whaat is the object ", object);

    this.materials = object.materials;
    this.unitNo = object.unitNo
    console.log('OBJECT', object);
    this.sendDataToAllocateModal = {
      learners: this.learners,
      materials: this.materials.length
    }
    console.log("what is selected material data", this.sendDataToAllocateModal);

  }
  assignmentAdded() {
    console.log("IN ASSIGNMENT ADDED METHOD");
    this.assignmentStatusComp.ngOnInit();
  }
  scheduler(job) {
    console.log("JOB found in scheculer", job);
    this.jobForScheduler = job;
  }

  allocateLearners() {
    this.learnersAlloted = false
    this.openDialog(AllocateLearnerModalComponent, this.sendDataToAllocateModal).subscribe((allocatedLearners) => {
      if (allocatedLearners == undefined) return
      let learners = [];
      let materialsNew = [];

      console.log("what is total material length", this.materials);


      this.materials.forEach(material => {
        let obj = {
          _id: material._id,
          title: material.title
        }
        if (material.assignmentNo != null) {
          obj['assignmentNo'] = material.assignmentNo
        }
        materialsNew.push(obj)
      })
      console.log("final array of materialssssssss", materialsNew);
      if (this.unitNo != null) {
        materialsNew['unitNo'] = this.unitNo
      }

      if (allocatedLearners) {
        allocatedLearners.forEach((learner) => {
          let newlearner = { _id: learner._id, name: learner.name, email: learner.email, duedate: learner.duedate }


          console.log(" jobId ", this.jobId)

          learners.push({
            learner: newlearner,
            assignments: materialsNew, job: this.jobId
          });
        });
      }
      console.log("check the unit number", this.unitNo);

      console.log('Final Allotment=====>', learners)
      console.log("value of single job details", this.job);



      this._learnerService.allocateLearner(learners).subscribe(() => {
        console.log("DATA SENT", learners);
        this.learnersAlloted = true
        console.log("*****this.learnersAlloted", this.learnersAlloted);
        if (this.job && this.job.course.type == 'Level3') {
          this.assignmentStatusComp.ngOnInit();
        }
      });
      this.materialsComp.clearCheckBox();
      this.openSnackBar("Materials allocated successfully!", "Ok");
    }, () => {
      return this.openSnackBar("Materials could not be allocated!", "Ok");
    });
  }
  allocatedFromMaterialTile(event) {
    console.log("In job", event);

    this.assignmentStatusComp.ngOnInit();
  }
  allocatedStatus(event) {
    console.log("allocatedFromStatus", event)
    this.allocated = true;
    // this.learnersAlloted = true
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  openSideNav(event) {
    console.log("OPEN SIDE NAV EVENT", event);
    this.displayDetails = true;
  }
  getJob() {
    this.loading = true;
    this._jobService.getJobById(this.jobId).subscribe((jobs) => {
      console.log("GETTING SINGLE JOB", jobs.data[0], this.job);
      this.jobForScheduler = jobs.data[0];
      this.job = jobs.data.pop();
      this.assignmentStatusWithLearner()
      this.getUserRole()
      console.log('%c THIS IS THE JOB IN THE JOB COMP', "color:purple", this.job)
      if (this.job && this.job.course.courseMetaId) {
        console.log('%c THIS IS THE JOB IN THE JOB COMP IN IF', "color:purple", this.job.course.courseMetaId)
        if (this.job.course.courseMetaId.hasPolicy) {
          console.log('%c THIS IS THE JOB IN THE JOB COMP IN SECOND IF', "color:purple", this.job.course.courseMetaId.hasPolicy)
          this.hasPolicy = 'hasPolicy'
        } else {
          this.hasPolicy = 'noPolicy'
        }
        console.log("HELLO HERE IS ::", this.job.course)

        if (this.job.course && this.job.course.hasExam) {
          this.isExamTab = this.job.course.hasExam
        }

      }
      // if (this.job && this.job.course && this.job.course.materials && this.job.course.materials[0] && this.job.course.materials[0]._id) {
      //   this.newMaterial = this.job.course.materials;
      // } else {
      //   this.newMaterial = [];
      // }
      this.completionPercentage(this.job)
      this.instForClient = this.job.instructors
      console.log("Setting job = ", { job: this.job });
      this.loading = false;
    });
  }
  openFileDetails(event) {
    this.openFilesSideNav.emit({ event })
  }

  getLearners(jobId) {
    this.gettingLearners = true
    this._learnerService.getLearnersByJobId(jobId).subscribe(responseLearner => {
      this.allLearners = responseLearner;
      this.gettingLearners = false
      console.log("this.allLearners in job", this.allLearners);
    })
  }
  assignmentStatusWithLearner() {
    this.gettingStatWithLearn = true
    console.log("this.jobId in assignmentStatusWithLearner", this.job);
    let data = {
      _id: this.jobId,
      courseId: this.job.course._id
    }
    // this._materialService.assignmentStatusWithLearner(data).subscribe(responseData => {
    //   console.log("assignmentStatusWithLearner responseData", responseData);
    //   this.learnerAssignmentStatus = responseData
    //   this.gettingStatWithLearn = false
    // })

    if (this.job.course.courseMetaId.trackerType.includes('file')) {
      this._materialService.getAssignmentListForChild(data).subscribe((response) => {
        console.log("response of all learner with status", response);
        if (response && response.length) {
          this.learnerAssignmentStatus = response
        }
        this.gettingStatWithLearn = false
      })
    } else {
      this.gettingStatWithLearn = false
    }


    if (this.job.course.courseMetaId.trackerType.includes('quiz')) {

      this._materialService.quizStatusWithLearner(data).subscribe((response) => {
        console.log("response of all learner with quiz status", response);
        this.quizStatusLearner = response
        // this.learnerAssignmentStatus = response
        this.gettingStatWithLearn = false
      })
    } else {
      this.gettingStatWithLearn = false
    }
  }

  getUserRole() {
    console.log("this is the value of selected job", this.jobForScheduler);


    let getRole = this._userRoleService.getUserRole(this.jobForScheduler.instructors, 'job')

    // let getRole = this._userRoleService.getUserRole(this.jobForScheduler.instructors, 'job');

    console.log("getRole ?? ", getRole);
    if (getRole.isAdmin) return this.userRole = 'admin'
    else if (getRole.isLearner) return this.userRole = 'learner'
    else if (getRole.isClient) return this.userRole = 'client'
    else if (getRole.isTrainer) return this.userRole = 'trainer'
    else if (getRole.isIQA) return this.userRole = 'IQA'
  }

  completionPercentage(job) {
    console.log("what is the single job data", job);

    this._timeSheetService.getSystemDate().subscribe((date) => {
      // if (job && job.singleJobDate) {
      let start;
      let end;
      // if (job && job.singleJobDate.length && job.scheduleDates == false) {
      //   this.startDate = new Date(job.singleJobDate[0]);
      //   this.endDate = new Date(job.singleJobDate[job.singleJobDate.length - 1])

      //   start = new Date(job.singleJobDate[0]).getTime()
      //   end = new Date(job.singleJobDate[job.singleJobDate.length - 1]).getTime()
      // } else {
      //   this.startDate = new Date(job.startingDate);
      //   this.endDate = new Date(job.endingDate);

      //   start = new Date(job.startingDate).getTime()
      //   end = new Date(job.endingDate).getTime()
      // }

      if (job.scheduleDates && job.scheduleDates == true) {
        this.startDate = new Date(job.startingDate);
        this.endDate = new Date(job.endingDate);

        start = new Date(job.startingDate).getTime()
        end = new Date(job.endingDate).getTime()
      } else {
        this.startDate = new Date(job.singleJobDate[0].date);
        this.endDate = new Date(job.singleJobDate[job.singleJobDate.length - 1].date)

        start = new Date(job.singleJobDate[0].date).getTime()
        end = new Date(job.singleJobDate[job.singleJobDate.length - 1].date).getTime()
      }


      let today = date.sytemTime
      let totalDays = (end - start) / (1000 * 3600 * 24)
      let daysPassed = (today - start) / (1000 * 3600 * 24)
      this.completionPercent = Math.round((daysPassed / totalDays) * 100);

      if (this.completionPercent < 0) {
        this.completionPercent = 0;
      }
      if (this.completionPercent > 100) {
        this.completionPercent = 100;
      }
      this.completionPercentForClient.emit({ percent: this.completionPercent })
      // }
    })


  }
  formatSubtitle = () => {
    return "complete"
  }
  changeParams(event) {
    this.closeFilesSideNav.emit('close')
    this.allocated = false;
    // this.learnersAlloted = false
    // /jobs/5e6c6fd95e06144dc8b324e0
    // window.history.replaceState({}, '', `/jobs/${personId}/${tabIndex}`)
    console.log("Tab changed =====>>>>> ", event)
    // go to go back in tabs
    // replaceState to go back to job.
    if (this.changeTab) {
      if (event.tab.textLabel == 'Exams') {
        this.callGetMarks = true
      }
      if (event.tab.textLabel == 'Course') {
        this.location.replaceState(
          this.router.createUrlTree(
            [this.locationStrategy.path().split('?')[0]], // Get uri
            {
              relativeTo: this.activatedRoute, queryParams: {
                courseId: this.job.course._id, currentTab: event.index
              },
              queryParamsHandling: 'merge'
            }
          ).toString()
        );
      }
      else {
        this.location.replaceState(
          this.router.createUrlTree(
            [this.locationStrategy.path().split('?')[0]], // Get uri
            { relativeTo: this.activatedRoute, queryParams: { currentTab: event.index }, queryParamsHandling: 'merge' }).toString()
        );
      }
    }
    else {
      this.jobTabIndex.emit({ index: event.index })
    }

    // this.location.go(this.router.createUrlTree([this.router.url], { queryParams: { currentTab: event.index } }).toString())
    //   if (this.changeTab) {
    //     if (event.tab.textLabel == 'Course') {
    //       this.router.navigate([], {
    //         relativeTo: this.activatedRoute, queryParams: {
    //           courseId: this.job.course._id, currentTab: event.index
    //         },
    //       });
    //     }
    //     else {
    // this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { currentTab: event.index } });
    //     }
    //   }
    //   else {
    //     console.log("in else emitting event", event.index)
    //     this.jobTabIndex.emit({ index: event.index })
    //   }
  }

  getMaterials() {
    this._jobService
      .getMaterialsUsingJobId(this.jobId)
      .subscribe(res => {
        console.log("RES MATERIALS", res)
        this.materialsWithLearners = res
      })
  }
  unitList(event) {
    // console.log("when get all units list", event);
    this.allUnitsList = event
  }


  sideNavClose(event) {
    console.log("event when unit is changed", event);
    this.closeFilesSideNav.emit('close')
  }
  listOfAssignment(event) {
    console.log("all list of assignment ", event);
    this.allAssignmentList = event
  }


  jobEdit(event) {
    console.log("event while job edit", event);
    this.isEditJob = event
  }
}